import { request } from './request'
import { useServerFetch } from '../composables/useServerFetch'
import { useEnvApi } from '../composables/useEnvApi'

const REGULATOR_BLACKLIST_LIST_API_PATH = '/api/v4/bit/web/regulator/blacklist/list'

export type WebRegulatorBrokerTag = {
  text?: string
  textColor?: string
}

export type WebRegulatorBrokerItem = {
  alias: string | undefined
  brokerIcon?: string
  brokerCode?: string
  brokerShortName?: string
  business?: string | string[]
  businessText?: string
  country?: string
  countryName?: string
  operatingYears?: string
  operatingYearsText?: string
  businessTypes?: string
  score?: string
  ultimateUltraIco?: string
  tags?: WebRegulatorBrokerTag[]
}

export type WebRegulatorBlacklistListResponseData = {
  blacklistCount?: number
  blacklistList?: WebRegulatorBrokerItem[]
}

export type WebRegulatorBlacklistListWrappedResponse = {
  data?: WebRegulatorBlacklistListResponseData
  succeed?: boolean
  code?: number
  message?: string
}

export type GetWebRegulatorBlacklistListParams = {
  regulatorCode: string
  business?: string
  page?: number
  size?: number
}

export const getRegulatorBlacklistList = async (
  params: GetWebRegulatorBlacklistListParams,
): Promise<WebRegulatorBlacklistListResponseData | null> => {
  if (!params.regulatorCode) {
    return null
  }

  const api = useEnvApi()
  const requestConfig = {
    baseURL: api.wikibitBffGo,
    url: REGULATOR_BLACKLIST_LIST_API_PATH,
    method: 'GET' as const,
    params: {
      regulatorCode: params.regulatorCode,
      business: params.business || '',
      page: params.page || 1,
      size: params.size || 20,
    },
  }

  const response = import.meta.server
    ? await useServerFetch<WebRegulatorBlacklistListWrappedResponse>(requestConfig)
    : await request<unknown, WebRegulatorBlacklistListWrappedResponse>(requestConfig)

  if (!response || !response.data) {
    return null
  }

  return response.data
}
